import { Directive, ElementRef, OnInit } from '@angular/core';
import { fromEvent } from 'rxjs';

@Directive({
  selector: 'ion-segment'
})
export class HorizontalScrollDirective implements OnInit {
  // The purpose of this directive is to allow horizontal scrolling with mouse wheel

  constructor(private el: ElementRef) {}

  ngOnInit() {
    fromEvent(this.el.nativeElement, 'wheel').subscribe(({ deltaY }) => {
      this.el.nativeElement.scrollLeft -= deltaY * 30;
    });
  }
}
